import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Buyer, BuyersService } from 'src/app/core/buyers.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';

@Component({
  selector: 'app-buyers-access-control-dialog',
  templateUrl: './buyers-access-control-dialog.component.html',
  styleUrls: ['./buyers-access-control-dialog.component.scss'],
})
export class BuyersAccessControlDialogComponent {
  buyer?: Buyer;
  is_buyer_edit_running: boolean = false;

  constructor(
    private dialog_ref: MatDialogRef<BuyersAccessControlDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: any,
    private buyers_service: BuyersService,
    private error_service: ErrorService,
  ) {
    this.buyer = data.buyer;
    console.log('Buyer data:', this.buyer);
  }

  unblock(buyer: Buyer): void {
    this.is_buyer_edit_running = true;
    console.log('isBlocked', this.isBlocked());
    if (this.isBlocked()) {
      console.warn('Buyer is already unblocked, cannot unblock.');
      this.is_buyer_edit_running = false;
      return;
    }
    this.buyers_service.unblock(buyer).subscribe({
      next: () => {
        this.dialog_ref.close({ success: true });
        this.is_buyer_edit_running = false;
      },
      error: error => {
        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.dialog_ref.close({ error: processed_error });
        this.is_buyer_edit_running = false;
      },
    });
  }

  isBlocked(): boolean {
    return !this.buyer?.blocked_at;
  }
}
